import { useMutation } from 'react-query'
import { AppEvents } from 'src/constants'

import AuthDataService from 'src/services/auth.service'
import { ISignupAccountCreateCheckDto } from 'src/types'

export const useSignupAccountPreCreateCheck = () => {
  return useMutation(
    (dto: ISignupAccountCreateCheckDto) => AuthDataService.signupAccountExistCheck(dto),
    {
      onSuccess(data) {
        if (!data) return

        const detail = { message: data.existMessage }
        window.document.dispatchEvent(new CustomEvent(AppEvents.HTTP_WARNING, { detail }))
      },
    },
  )
}
